export { view as Faq } from './view'
